import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const OfficeBuilding: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 24, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <path fillRule="evenodd" clipRule="evenodd" d="M17 5H7V19H17V5ZM7 3C5.89543 3 5 3.89543 5 5V19V21H7H17H19V19V5C19 3.89543 18.1046 3 17 3H7ZM9 11H11V13H9V11ZM11 7H9V9H11V7ZM13 11H15V13H13V11ZM15 7H13V9H15V7ZM9 15H11V17H9V15ZM15 15H13V17H15V15Z" fill={color} />
</svg>);
export default OfficeBuilding;